<template>
  <section class="custom-wrapper">
    <div class="row mt-2 mb-3">
      <div class="col-12">
        <h5 class="mb-3">Service List Configuration</h5>
        <p class="text-muted mb-4">Select the services your business offers to customers.</p>
        
        <div class="service-list-container">
          <div 
            v-for="service in serviceListOptions" 
            :key="service.id" 
            class="service-list-item mb-3"
          >
            <div class="form-check">
              <input 
                class="form-check-input" 
                type="checkbox" 
                :id="service.id"
                :value="service.id"
                v-model="selectedServices"
                @change="changed"
              >
              <label class="form-check-label" :for="service.id">
                <strong>{{ service.name }}</strong>
              </label>
            </div>
          </div>
        </div>
        
        <div v-if="selectedServices.length === 0" class="alert alert-info mt-3">
          <i class="fas fa-info-circle me-2"></i>
          Please select at least one service to indicate what services you offer to your customers.
        </div>
        
        <div v-else class="alert alert-success mt-3">
          <i class="fas fa-check-circle me-2"></i>
          You have selected {{ selectedServices.length }} service{{ selectedServices.length > 1 ? 's' : '' }}.
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { locationStore } from '@/stores/location'

export default {
  name: 'ServiceList',
  props: {
    firm: Object
  },
  emits: ['changed'],
  computed: {
    ...mapState(locationStore, ['profileData', 'serviceListOptions', 'location']),
    launchpadFirmId() {
      return this.location?.firmId || this.launchpadFirmId
    },
    selectedServices: {
      get() {
        return this.profileData?.serviceList || []
      },
      set(value) {
        this.updateProfileField('serviceList', value, this.launchpadFirmId)
      }
    }
  },
  methods: {
    ...mapActions(locationStore, ['updateProfileField', 'saveProfileData']),
    changed() {
      this.$emit('changed')
    },
    async save() {
      if (this.launchpadFirmId) {
        await this.saveProfileData(this.launchpadFirmId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
  position: relative;
  padding: 20px;
}

h5 {
  color: #495057;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 0.5rem;
}

.service-list-container {
  margin-top: 1rem;
}

.service-list-item {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
  transition: all 0.2s ease-in-out;
  
  &:hover {
    border-color: #80bdff;
    background-color: #e7f3ff;
  }
}


.form-check {
  margin-bottom: 0.5rem;
}

.form-check-input {
  margin-top: 0.125rem;
  
  &:checked {
    background-color: #0d6efd;
    border-color: #0d6efd;
  }
  
  &:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
}

.form-check-label {
  cursor: pointer;
  margin-left: 0.5rem;
  
  strong {
    color: #495057;
    font-size: 1.1rem;
  }
}

.alert {
  border-radius: 0.5rem;
  
  i {
    font-size: 1rem;
  }
}

.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}

.alert-success {
  background-color: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.text-muted {
  color: #6c757d !important;
}
</style>